const scheduledServicesPlannerHeader = {
  scheduledServices: "Serviços Agendados",
};

export default scheduledServicesPlannerHeader;
